import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { createPostCategory } from "../../../../graphql/mutations";
import SimpleCreateEdit from "../../../Common/Crud/SimpleCreateEdit";
import TextInput from "../../../../components/Common/TextInput";
import * as PostCategoriesConstants from "../../../../graphql/Constants/PostCategories/Types";
import nameChangeHandler from "../../../Common/Crud/formHandlers/nameChangeHandler";
import orderChangeHandler from "../../../Common/Crud/formHandlers/orderChangeHandler";
import nameOnlyFormsValidationHandler from "../../../Common/Crud/formHandlers/nameOnlyFormsValidationHandler";
import * as CrudActionTypes from "../../../../constants/Crud/ActionTypes";
import * as ModelTypes from "../../../../graphql/Constants/ModelTypes";

const PostCategoryCreate = (props) => {
  // states
  const [name, setName] = useState("");
  const [order, setOrder] = useState(0);
  const [inputFieldsDisable, setInputFieldsDisable] = useState(false);
  const [errors, setErrors] = useState({});
  const [createButtonDisableStatus, setCreateButtonDisableStatus] = useState(
    false
  );

  const handleCreatePostCategory = async () => {
    try {
      const input = {
        type: ModelTypes.PostCategory,
        name: name.trim(),
        order: order,
        deletedAt: null,
      };
      await API.graphql(graphqlOperation(createPostCategory, { input }));
      return { result: true, message: `PostCategory created successfully` };
    } catch (error) {
      return { result: false, message: `Error creating PostCategory, ${error}` };
    }
  };

  return (
    <SimpleCreateEdit
      {...props}
      crudActionType={CrudActionTypes.Create}
      returnHandler={() => props.history.push(`/postCategories`)}
      modelName="Post Category"
      // createOrUpdateDisableMethod={(modelData) => {
      //   if (modelData.id === PostCategorysConstants.Other.id) return true;
      //   return false;
      // }}
      // createOrUpdateDisabledActions={() => {
      //   setNameInputTextDisable(true);
      // }}
      formSubmissionHandler={handleCreatePostCategory}
      formValidationHandler={() =>
        nameOnlyFormsValidationHandler(
          name,
          "PostCategory",
          false, // we need to exclude the OTHER,
          setCreateButtonDisableStatus,
          setErrors
        )
      }
      setErrorsState={() => setErrors}
      actionButtonDisabledState={createButtonDisableStatus}
    >
      <TextInput
        type="name"
        id="name"
        label="Post Category Name"
        placeholder="Enter a Post Category name"
        value={name}
        onChange={(e) =>
          nameChangeHandler(
            e,
            "PostCategory",
            false, // we need to exclude the OTHER,
            setName,
            setCreateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.name}
        disabled={inputFieldsDisable}
      />
      <TextInput
        type="number"
        id="order"
        label="Post Category Order"
        placeholder="Enter a Post Category Order"
        value={order}
        onChange={(e) =>
          orderChangeHandler(
            e,
            "PostCategory",
            setOrder,
            setCreateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.order}
        disabled={inputFieldsDisable}
      />
    </SimpleCreateEdit>
  );
};

export default PostCategoryCreate;
